<template>
  <dt class="header column-12 tablet:column-3 laptop:column-2 margin-top-xs tablet:margin-top-0 padding-sm muted">
    <span
      :aria-label="featureDescription"
      data-balloon-pos="right"
    >
      <font-awesome-icon
        :icon="$v6.solid[featureIcon]"
        size="lg"
        fixed-width
        class="decorative margin-right-2xs"
      />
      <span style="text-decoration: underline; cursor: pointer">{{ featureName }}</span>
    </span>
  </dt>
</template>
<script>
  export default {
    name: 'TableCellHead',

    props: {
      featureName: {
        type: String
      },
      featureIcon: {
        type: String
      },
      featureDescription: {
        type: String
      }
    }
  }
</script>
